import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';

import InputRange from 'common/components/modules/input-range';
import Input from 'common/components/elements/inputs/inputs';
import SelectLogoColor from 'admin/views/site-designer/modules/sections/customize-logo-modal/select-color';

const IconSvgConvert = ({
   settings,
   fontList,
   setSettings,
   colors,
   onSelectFont,
   onChangeText,
   isMobile,
}) => {
   const [scrollLeft, setScrollLeft] = useState(0)
   const [hiddenButtons, setHiddenButtons] = useState(true)

   function handleClick(direction){
      const container = document.querySelector('#favicon_font_list')
      sideScroll(container, direction, 80, 100, 250);
   }
   function sideScroll(element, direction, speed, distance, step){
      let scrollAmount = 0;
      let left = element.scrollLeft
      var slideTimer = setInterval(function(){
         if(direction === 'left'){
            left -= step;
            setScrollLeft(left)
         } else {
            left += step;
            setScrollLeft(left)
         }
         element.scrollTo(left, 0)
         scrollAmount += step;
         if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
         }
      }, speed);

   }
   const element = document.querySelector('#favicon_font_list')
   let scrollEnd = 0
   if(element) {
      scrollEnd = element.scrollWidth - element.getBoundingClientRect().width
   }
   return (
      <>
         <div
            role='presentation'
            onFocus={ () => {
               if(isMobile) return
               setHiddenButtons(false)
            } }
            onMouseOver={ () => {
               if(isMobile) return
               setHiddenButtons(false)
            } }
            onMouseLeave={ () => {
               if(isMobile) return
               setHiddenButtons(true)
            } }
            className='bg-panel w-full py-7 flex relative'>
            {
               (!hiddenButtons && scrollLeft > 0) && (
                  <div
                     style={ {
                        top: '50px',
                     } }
                     className='shadow dark:shadow-dark absolute left-0  z-10 ml-3 w-9 h-9 scroll-button rounded-full bg-panel border border-divider'>
                     <Button
                        classNames='w-full h-full'
                        padding='none'
                        borderRadius='full'
                        backgroundColor='panel'
                        fontIconColor='major'
                        fontIconSize='large'
                        iconName='arrow-left'
                        onClick={ () => handleClick('left') }
                     />
                  </div>

               )
            }
            <div
               id='favicon_font_list'
               className='flex items-center overflow-x-auto'>
               {
                  fontList.map(item => {
                     return (
                        <div
                           style={ {
                              minHeight: '80px',
                              minWidth: '80px',
                           } }
                           key={ item.value.toString() }
                           onClick={ () => onSelectFont(item)  }
                           role='presentation'
                           className={ `w-20 h-20 flex items-center justify-center mx-2 rounded-label cursor-pointer border
                           p-1 ${ settings.font_name === item.name ? ' border-action' : 'border-divider' }` }
                        >
                           <FaviconSvg
                              font={ item }
                              settings={ settings }
                              isId={ settings.font_name === item.name }
                           />
                        </div>
                     )
                  })
               }
            </div>
            {
               (!hiddenButtons && ((scrollLeft !== scrollEnd && scrollLeft < scrollEnd) || scrollLeft === 0)) && (
                  <div
                     style={ {
                        top: '50px',
                     } }
                     className='shadow dark:shadow-dark absolute right-0 mr-3  w-9 h-9 scroll-button rounded-full  bg-panel border border-divider'>

                     <Button
                        classNames='w-full h-full'
                        padding='none'
                        borderRadius='full'
                        fontIconColor='major'
                        fontIconSize='large'
                        backgroundColor='panel'
                        iconName='arrow-right'
                        onClick={ () => handleClick('right') }
                     />
                  </div>
               )
            }
         </div>
         <div
            className='overflow-y-auto flex-1 flex flex-col  ams-custom-scrool gap-6'
         >
            <div className='w-20'>
               <Input
                  onChange={ onChangeText }
                  value={ settings.text }
                  label='Text'
               />
            </div>
            <InputRange
               onChange={ (name, value) => {
                  setSettings({
                     ...settings,
                     [name]: value,
                  })
               } }
               value={ settings.font_size }
               name='font_size'
               minValue={ 0 }
               maxValue={ 120 }
               step={ 1 }
               inputLabel='Font Size'
               className='w-full'
               inputWrapperClassName='w-full'
            />

            <SelectLogoColor
               colors={ colors }
               onSelect={ (color, isCustom) => {
                  let colors = {}

                  if(isCustom) {
                     colors = { custom_text_color: color }
                  }
                  setSettings({
                     ...settings,
                     ...colors,
                     color,
                  }) } }
               customColor={ settings.custom_text_color || '#F8F9FA' }
               activeColor={ settings.color }
               id='icon_text'
               label='Font color'
               isMobile={ isMobile }
            />

            <SelectLogoColor
               colors={ colors }
               onSelect={ (color, isCustom) => {
                  if(isCustom) {
                     colors = {  custom_bg_color: color }
                  }
                  const isShowBg = '#FFFFFF' === color.toUpperCase() || '#FFF' === color.toUpperCase()
                  setSettings({
                     ...settings,
                     background: color,
                     stroke_color: isShowBg ? '#F2F4F7' : 'transparent',
                  }) } }
               customColor={ settings.custom_bg_color || '#F8F9FA' }
               activeColor={ settings.background }
               id='icon_bg'
               label='Backround color'
               isMobile={ isMobile }
            />
            <InputRange
               onChange={ (name, value) => {
                  setSettings({
                     ...settings,
                     [name]: value,
                  })
               } }
               value={ settings.dx }
               name='dx'
               minValue={ -29 }
               maxValue={ 120 }
               step={ 0.5 }
               inputLabel='Horizontal alignment'
               className='w-full'
               inputWrapperClassName='w-full'
            />
            <InputRange
               onChange={ (name, value) => {
                  setSettings({
                     ...settings,
                     [name]: value,
                  })
               } }
               value={ settings.dy }
               name='dy'
               minValue={ -29 }
               maxValue={ 120 }
               step={ 0.5 }
               inputLabel='Vertical Alignment'
               className='w-full'
               inputWrapperClassName='w-full'
            />
         </div>
      </>
   )
}

const FaviconSvg = ({ settings, font, isId }) => {
   return (
      <svg
         id={ isId ? 'app-icon-and-favicon' : '' }
         xmlns='http://www.w3.org/2000/svg'
         width='72' height='72'
         viewBox='0 0 100 100'
      >
         {/* <defs>
            <style type='text/css'>
               {fontBase64}
            </style>
         </defs> */}
         <g>
            <clipPath id='ams-app-icon'>
               <rect
                  x='0'
                  y='0'
                  rx={ 22 }
                  ry={ 22 }
                  width='100'
                  height='100'
               />
            </clipPath>
         </g>
         <g clipPath='url(#ams-app-icon)'>
            <rect
               x='0'
               y='0'
               rx={ 22 }
               ry={ 22 }
               width='100'
               height='100'
               fill={ settings.background  }
               stroke={ settings.background }
               strokeWidth={ 1 }
            />
            <text
               x='50'
               y='50'
               dx={ settings.dx }
               dy={ settings.dy }
               fill={ settings.color }
               fontSize={ settings.font_size }
               style={ {
                  fontFamily: font.font,
               } }
               fontFamily={ font.font }
               textAnchor='middle'
               dominantBaseline='central'
            >
               {settings.text}
            </text>
         </g>

      </svg>
   )
}

IconSvgConvert.propTypes = {
   settings: PropTypes.object,
   fontList: PropTypes.array,
   setSettings: PropTypes.func,
   colors: PropTypes.array,
   onSelectFont: PropTypes.func,
   onChangeText: PropTypes.func,
   isMobile: PropTypes.bool,
}

FaviconSvg.propTypes = {
   settings: PropTypes.object,
   font: PropTypes.object,
   isId: PropTypes.bool,
}

export default IconSvgConvert
